import { useSelector } from "react-redux"

function CalculatedStaffPrize(){
    const StaffSelectedCityArray = useSelector(state => state.StaffSlice.StaffSelectedCityArray)

    const Period = useSelector(state => state.PeriodSlice.Period)

    const RevenueArray = useSelector(state => state.RevenueSlice.RevenueArray)
    const PercentCity = useSelector(state => state.RevenueSlice.PercentCity)
    return(
        <div>
            <div
            className="StaffPercentMainDiv Margin"
            >
                
                
                {Period.MinDay < 14 &&
                <div
                className="DivFlex"
                >
                    <div
                    className="RevenueCityLongDiv ColoredGray"
                    >
                        {"Просчет премиальных"}
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray"
                    >
                        Касса
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>
                    
                    <div
                    className="RevenueTotalDiv NoneBorder"
                    >
                    </div>
                </div>
                }
                
                {Period.MaxDay > 15 &&
                <div
                className="DivFlex"
                >
                    <div
                    className="RevenueCityLongDiv ColoredGray"
                    >
                        {"Просчет премиальных"}
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray Second"
                    >
                        Касса
                    </div>
                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                    </div>
                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>
                </div>
                }
                                
            </div>
            {StaffSelectedCityArray.length > 0 && StaffSelectedCityArray.map((el) => 
            el.Post === "Кассир" && el.Hidden !== true &&
                <div
                className="StaffPercentMainDiv"
                >
                    {Period.MinDay < 14 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                        {el.FIO}
                    </div>
                    }
                    {el.Hours.map((a, index) => 
                    index < 15 && a.id > Period.MinDay && a.id < Period.MaxDay && 
                        <div
                        key={index}
                        className="DateDivRevenue"
                        >
                            {RevenueArray.length > 0 && a.Value > 0 && parseFloat(RevenueArray[a.id].Value) > PercentCity.PrizeMinSum ? parseFloat(parseFloat(PercentCity.PrizeSumKashier) * parseFloat(a.Value / el.Shift)).toFixed(2).replace('.', ',') : 0}
                            
                        </div>
                    )}
                        
                        {Period.MinDay < 14 &&
                        <div
                        className="DivFlex"
                        >
                            <div
                            className="RevenueTotalDiv"
                            >
                            </div>

                            <div
                            className="RevenueTotalDiv"
                            >
                                 {el.Hours.reduce((Sum, item) => item.id < 15 && RevenueArray.length > 0 && item.Value > 0 && parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum ? Sum + parseFloat(parseFloat(PercentCity.PrizeSumKashier) * parseFloat(item.Value / el.Shift)) : Sum + 0, 0).toFixed(2).replace('.', ',') + ' руб.'}
                            </div>

                            <div
                            className="RevenueTotalDiv NoneBorder"
                            >
                            </div>
                        </div>
                        }
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                        {el.FIO}
                    </div>
                    }

                    {el.Hours.map((a, index) => 
                    index > 14 && a.id > Period.MinDay && a.id < Period.MaxDay && 
                        <div
                        key={index}
                        className="DateDivRevenue"
                        >
                            {RevenueArray.length > 0 && a.Value > 0 && parseFloat(RevenueArray[a.id].Value) > PercentCity.PrizeMinSum ? parseFloat(parseFloat(PercentCity.PrizeSumKashier) * parseFloat(a.Value / el.SecondShift)).toFixed(2).replace('.', ',') : 0}
                            
                        </div>
                    )}
                    
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueTotalDiv"
                    >
                    </div>
                    }

                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueTotalDiv"
                    >
                        {el.Hours.reduce((Sum, item) => item.id > 14 && RevenueArray.length > 0 && item.Value > 0 && parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum ? Sum + parseFloat(parseFloat(PercentCity.PrizeSumKashier) * parseFloat(item.Value / el.SecondShift)) : Sum + 0, 0).toFixed(2).replace('.', ',') + ' руб.'}
                    </div>
                    }
                    
                </div>
            )}

            <div
            className="StaffPercentMainDiv"
            >
                
                {Period.MinDay < 14 &&
                <div
                className="DivFlex"
                >
                    <div
                    className="RevenueCityLongDiv ColoredGray"
                    >
                        {"Просчет премиальных"}
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray"
                    >
                        Повара (группа 1)
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>
                    
                    <div
                    className="RevenueTotalDiv NoneBorder"
                    >
                    </div>
                </div>
                }
                
                {Period.MaxDay > 15 &&
                <div
                className="DivFlex"
                >
                    <div
                    className="RevenueCityLongDiv ColoredGray"
                    >
                        {"Просчет премиальных"}
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray Second">
                        Повара (группа 1)
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                    </div>
                

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>
                </div>
                }
                
            </div>

            {StaffSelectedCityArray.length > 0 && StaffSelectedCityArray.map((el) => 
           (el.Post === "Повар" || el.Post === "Повар 1 группа") && el.Hidden !== true &&
                <div
                className="StaffPercentMainDiv"
                >
                    {Period.MinDay < 14 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                        {el.FIO}
                    </div>
                    }

                    {el.Hours.map((a, index) => 
                    index < 15 &&
                    a.id > Period.MinDay && a.id < Period.MaxDay && 
                        <div
                        key={index}
                        className="DateDivRevenue"
                        >
                            {RevenueArray.length > 0 && a.Value > 0 && parseFloat(RevenueArray[a.id].Value) > PercentCity.PrizeMinSum ? parseFloat(parseFloat(PercentCity.PrizeSumCook) * parseFloat(a.Value / el.Shift)).toFixed(2).replace('.', ',') : 0}
                            
                        </div>
                    )}
                        {Period.MinDay < 14 &&
                        <div
                        className="DivFlex"
                        >
                            <div
                            className="RevenueTotalDiv"
                            >
                            </div>
                            
                            <div
                            className="RevenueTotalDiv"
                            >
                                 {el.Hours.reduce((Sum, item) => item.id < 15 && RevenueArray.length > 0 && item.Value > 0 && parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum ? Sum + parseFloat(parseFloat(PercentCity.PrizeSumCook) * parseFloat(item.Value / el.Shift)) : Sum + 0, 0).toFixed(2).replace('.', ',') + ' руб.'}
                            </div>
                            
                            <div
                            className="RevenueTotalDiv NoneBorder"
                            >
                            </div>
                        </div>
                        }
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                        {el.FIO}
                    </div>
                    }

                    {el.Hours.map((a, index) => 
                    index > 14 &&
                    a.id > Period.MinDay && a.id < Period.MaxDay && 
                        <div
                        key={index}
                        className="DateDivRevenue"
                        >
                            {RevenueArray.length > 0 && a.Value > 0 && parseFloat(RevenueArray[a.id].Value) > PercentCity.PrizeMinSum ? parseFloat(parseFloat(PercentCity.PrizeSumCook) * parseFloat(a.Value / el.SecondShift)).toFixed(2).replace('.', ',') : 0}
                            
                        </div>
                    )}
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueTotalDiv"
                    >
                    </div>
                    }

                    
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueTotalDiv"
                    >
                        {el.Hours.reduce((Sum, item) => item.id > 14 && RevenueArray.length > 0 && item.Value > 0 && parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum ? Sum + parseFloat(parseFloat(PercentCity.PrizeSumCook) * parseFloat(item.Value / el.SecondShift)) : Sum + 0, 0).toFixed(2).replace('.', ',') + ' руб.'}
                    </div>
                    }
                    
                </div>
            )}

            <div
            className="StaffPercentMainDiv"
            >
                
                {Period.MinDay < 14 &&
                <div
                className="DivFlex"
                >
                    <div
                    className="RevenueCityLongDiv ColoredGray"
                    >
                        {"Просчет премиальных"}
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray"
                    >
                        Повара (группа 2)
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>
                    
                    <div
                    className="RevenueTotalDiv NoneBorder"
                    >
                    </div>
                </div>
                }
                
                {Period.MaxDay > 15 &&
                <div
                className="DivFlex"
                >
                    <div
                    className="RevenueCityLongDiv ColoredGray"
                    >
                        {"Просчет премиальных"}
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray Second">
                        Повара (группа 2)
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                    </div>
                

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>
                </div>
                }
                
            </div>

            {StaffSelectedCityArray.length > 0 && StaffSelectedCityArray.map((el) => 
            el.Post === "Повар 2 группа" && el.Hidden !== true &&
                <div
                className="StaffPercentMainDiv"
                >
                    {Period.MinDay < 14 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                        {el.FIO}
                    </div>
                    }

                    {el.Hours.map((a, index) => 
                    index < 15 &&
                    a.id > Period.MinDay && a.id < Period.MaxDay && 
                        <div
                        key={index}
                        className="DateDivRevenue"
                        >
                            {RevenueArray.length > 0 && a.Value > 0 && parseFloat(RevenueArray[a.id].Value) > PercentCity.PrizeMinSum ? parseFloat(parseFloat(PercentCity.PrizeSumCookSecondGroup) * parseFloat(a.Value / el.Shift)).toFixed(2).replace('.', ',') : 0}
                            
                        </div>
                    )}
                        {Period.MinDay < 14 &&
                        <div
                        className="DivFlex"
                        >
                            <div
                            className="RevenueTotalDiv"
                            >
                            </div>
                            
                            <div
                            className="RevenueTotalDiv"
                            >
                                 {el.Hours.reduce((Sum, item) => item.id < 15 && RevenueArray.length > 0 && item.Value > 0 && parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum ? Sum + parseFloat(parseFloat(PercentCity.PrizeSumCookSecondGroup) * parseFloat(item.Value / el.Shift)) : Sum + 0, 0).toFixed(2).replace('.', ',') + ' руб.'}
                            </div>
                            
                            <div
                            className="RevenueTotalDiv NoneBorder"
                            >
                            </div>
                        </div>
                        }
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                        {el.FIO}
                    </div>
                    }

                    {el.Hours.map((a, index) => 
                    index > 14 &&
                    a.id > Period.MinDay && a.id < Period.MaxDay && 
                        <div
                        key={index}
                        className="DateDivRevenue"
                        >
                            {RevenueArray.length > 0 && a.Value > 0 && parseFloat(RevenueArray[a.id].Value) > PercentCity.PrizeMinSum ? parseFloat(parseFloat(PercentCity.PrizeSumCookSecondGroup) * parseFloat(a.Value / el.SecondShift)).toFixed(2).replace('.', ',') : 0}
                            
                        </div>
                    )}
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueTotalDiv"
                    >
                    </div>
                    }

                    
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueTotalDiv"
                    >
                        {el.Hours.reduce((Sum, item) => item.id > 14 && RevenueArray.length > 0 && item.Value > 0 && parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum ? Sum + parseFloat(parseFloat(PercentCity.PrizeSumCookSecondGroup) * parseFloat(item.Value / el.SecondShift)) : Sum + 0, 0).toFixed(2).replace('.', ',') + ' руб.'}
                    </div>
                    }
                    
                </div>
            )}

            
            
            
        </div>
    )
}

export default CalculatedStaffPrize